import CookieBanner from './CookieBanner'

export default CookieBanner
